import { Injectable } from '@angular/core';
import { SocketResponseDto, SocketTruckDto } from '@fleet-beat/core';
import { Socket } from 'ngx-socket-io';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SocketIoService {
  constructor(private socket: Socket) {}

  sendMessage(message: string, params?: { boundingBox: string }): void {
    this.socket.emit(`${message}`, params);
  }
  getMessage(message: string): Observable<SocketResponseDto<SocketTruckDto>> {
    return this.socket.fromEvent<SocketResponseDto<SocketTruckDto>>(`${message}`);
  }

  onConnect(): void {
    if (!this.socket.ioSocket.connected) {
      this.socket.connect();
    }
  }

  ondisconnect(): void {
    this.socket.disconnect();
  }
}
